/**
 * @desc 创建费用申请单
 */
const URL = "/rantion-rms";
import http, { updateResponse } from "@/http";
export type Response = defs.rms.Response;
export function request(
  body: defs.rms.ExpenseReimbursementRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/expenseReimbursement/createExpenseReimbursementFormApproval`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
